<template>
  <div>
    <div id="allmap"></div>
  </div>
</template>
<script>
import BMapLib from "@/assets/js/InfoBox_min.js";
export default {
  name: "Map",
  data() {
    return {
      fire_city: [
        [
          116.403206,
          39.915219,
          "北京",
          [
            "中智商展（北京）国际会议展览股份公司",
            "智云经略（北京）营销策划有限公司",
            "智联未来（北京）企业咨询管理有限公司"
          ]
        ],
        [121.481315, 31.239145, "上海", ["上海智衍会展服务有限公司"]],
        [
          104.072941,
          30.671001,
          "成都",
          ["中智商展（北京）国际会议展览股份公司-成都分公司"]
        ],
        [
          113.270793,
          23.138232,
          "广州",
          ["中智商展（北京）国际会议展览股份公司-广州分公司"]
        ]
      ],
      world_city: [
        [8.681613, 50.113661, "法兰克福"],
        [-122.463302, 37.765372, "旧金山"],
        [-74.174925, 40.704555, "纽约"],
        [103.894811, 1.467152, "新加坡"],
        [139.769539, 35.995243, "东京"],
        [2.136056, 41.384347, "巴塞罗那"],
        [2.444211, 48.965442, "巴黎"],
        [151.177732, -33.880228, "悉尼"],
        [-0.314809, 51.573515, "伦敦"],
        [13.2, 52.31, "柏林"],
        [6.47, 51.13, "杜塞尔多夫"],
        [-81.31, 41.04, "阿科隆"],
        [11.35, 48.08, "慕尼黑"],
        [9.1, 45.28, "米兰"],
        [16.22, 48.13, "维也纳"],
        [12.37, 41.52, "罗马"],
        [3.45, 40.25, "马德里"],
        [-1.55, 52.3, "伯明翰"],
        [-86.55, 33.3, "伯明翰"],
        [4.52, 52.21, "阿姆斯特丹"],
        [7.36, 47.34, "巴塞尔"],
        [6.04, 46.14, "日内瓦"],
        [37.37, 55.45, "莫斯科"],
        [4.21, 50.51, "布鲁塞尔"],
        [16.53, 52.25, "波兹南"],
        [100.29, 13.5, "曼谷"],
        [-115.1, 36.1, "拉斯维加斯"],
        [-87.41, 41.51, "芝加哥"],
        [-90.05, 29.58, "新奥尔良"],
        [55.18, 25.16, "迪拜"],
        [-77.02, 38.53, "华盛顿"],
        [-118.2436849, 34.0522342, "洛杉矶"],
        [-122.2, 47.38, "西雅图"],
        [-95.22, 29.46, "休斯顿"],
        [-75.1311874, 40.0152766, "费城"],
        [-83.2, 42.19, "底特律"],
        [-71.05, 42.19, "波士顿"],
        [-79.59, 40.26, "匹兹堡"],
        [-84.25, 33.46, "亚特兰大"]
      ],
      china_city: [
        [109.508268, 18.247872, "三亚市"],
        [112.338651, 16.831004, "三沙市"],
        [111.194099, 34.777338, "三门峡市"],
        [104.184491, 30.687848, "上海市"],
        [117.971185, 28.44442, "上饶市"],
        [113.746262, 23.046237, "东莞市"],
        [118.66471, 37.434564, "东营市"],
        [113.382391, 22.521113, "中山市"],
        [111.517973, 36.08415, "临汾市"],
        [118.326443, 35.065282, "临沂市"],
        [100.08697, 23.886567, "临沧市"],
        [124.383044, 40.124296, "丹东市"],
        [119.921786, 28.451993, "丽水市"],
        [100.233026, 26.872108, "丽江市"],
        [120.075058, 29.306841, "义乌市"],
        [87.616842, 43.82539, "乌鲁木齐市"],
        [103.761263, 29.582024, "乐山市"],
        [104.125823, 30.623123, "九寨沟市"],
        [115.992811, 29.712034, "九江市"],
        [110.753975, 19.612986, "文昌市"],
        [113.453974, 30.364953, "仙桃市"],
        [81.317946, 43.92186, "伊犁市"],
        [113.122717, 23.028762, "佛山市"],
        [130.361634, 46.809606, "佳木斯市"],
        [115.464585, 38.87445, "保定市"],
        [99.167133, 25.111802, "保山市"],
        [114.075031, 32.123274, "信阳市"],
        [109.576782, 19.517486, "儋州市"],
        [84.873946, 45.595886, "克拉玛依市"],
        [116.507676, 31.752889, "六安市"],
        [104.846743, 26.584643, "六盘水市"],
        [103.834249, 36.06081, "兰州市"],
        [102.258746, 27.886762, "凉山市"],
        [109.840405, 40.658168, "包头市"],
        [104.09445, 30.592471, "北京市"],
        [109.119254, 21.473343, "北海市"],
        [110.798657, 32.629034, "十堰市"],
        [119.078201, 29.606841, "千岛湖市"],
        [104.06806, 30.53386, "南京市"],
        [106.082974, 30.795282, "南充市"],
        [108.36637, 22.817746, "南宁市"],
        [118.178459, 26.635627, "南平市"],
        [115.857963, 28.683016, "南昌市"],
        [120.864608, 32.016212, "南通市"],
        [112.540918, 32.999082, "南阳市"],
        [118.110221, 24.490474, "厦门市"],
        [121.428599, 28.661378, "台州市"],
        [121.487362, 24.906057, "台湾"],
        [117.227308, 31.82057, "合肥市"],
        [114.986373, 27.111699, "吉安市"],
        [126.55302, 43.843577, "吉林市"],
        [89.187359, 42.951279, "吐鲁番地区"],
        [111.134335, 37.524366, "吕梁市"],
        [114.649653, 33.620357, "周口市"],
        [119.778829, 49.166144, "呼伦贝尔市"],
        [111.748426, 40.842723, "呼和浩特市"],
        [114.328963, 29.832798, "咸宁市"],
        [108.705117, 34.333439, "咸阳市"],
        [93.51316, 42.833248, "哈密市"],
        [126.535319, 45.803131, "哈尔滨市"],
        [103.525435, 30.432927, "唐山市"],
        [115.650497, 34.437054, "商丘市"],
        [109.918561, 33.872706, "商洛市"],
        [103.966739, 30.534803, "喀什市"],
        [120.750865, 30.762653, "嘉兴市"],
        [98.277304, 39.786529, "嘉峪关市"],
        [105.057987, 29.580148, "内江市"],
        [124.370785, 43.170344, "四平市"],
        [104.094047, 30.592744, "大兴安岭市"],
        [113.295259, 40.09031, "大同市"],
        [125.11272, 46.590734, "大庆市"],
        [103.988474, 30.657236, "大理州市"],
        [100.225668, 25.589449, "大理市"],
        [121.618622, 38.91459, "大连市"],
        [105.724998, 34.578529, "天水市"],
        [117.201538, 39.085294, "天津市"],
        [113.165862, 30.653061, "天门市"],
        [121.13055, 31.457735, "太仓市"],
        [112.549717, 37.87046, "太原市"],
        [122.116394, 37.509691, "威海市"],
        [112.008497, 27.728136, "娄底市"],
        [113.926656, 30.926423, "孝感市"],
        [119.527082, 26.659241, "宁德市"],
        [121.6216, 29.859515, "宁波市"],
        [117.043551, 30.50883, "安庆市"],
        [109.029273, 32.6903, "安康市"],
        [113.883991, 35.302616, "新乡市"],
        [114.352482, 36.103442, "安阳市"],
        [105.932188, 26.245544, "安顺市"],
        [104.630825, 28.760189, "宜宾市"],
        [111.286451, 30.69187, "宜昌市"],
        [114.375165, 27.80201, "宜春市"],
        [107.14487, 34.369315, "宝鸡市"],
        [118.757995, 30.945667, "宣城市"],
        [116.984084, 33.633891, "宿州市"],
        [118.275162, 33.963008, "宿迁市"],
        [113.132855, 29.37029, "岳阳市"],
        [117.8618, 31.598628, "巢湖市"],
        [106.753669, 31.858809, "巴中市"],
        [119.946973, 31.772752, "常州市"],
        [111.691347, 29.040225, "常德市"],
        [106.684691, 35.54279, "平凉市"],
        [113.307718, 33.735241, "平顶山市"],
        [109.479665, 30.29468, "恩施市"],
        [105.829757, 32.433668, "广元市"],
        [106.633369, 30.456398, "广安市"],
        [113.264385, 23.129112, "广州市"],
        [104.03692, 30.68694, "广西壮族自治区"],
        [107.638372, 35.734218, "庆阳市"],
        [116.704441, 39.523927, "廊坊市"],
        [109.49081, 36.596537, "延安市"],
        [128.232013, 43.372413, "延边市"],
        [114.341447, 34.797049, "开封市"],
        [114.884091, 40.811901, "张家口市"],
        [110.479921, 29.127401, "张家界市"],
        [100.455472, 38.932897, "张掖市"],
        [117.184811, 34.261792, "徐州市"],
        [116.307428, 37.453968, "德州市"],
        [104.398651, 31.127991, "德阳市"],
        [112.733538, 38.41769, "忻州市"],
        [109.97824, 27.550082, "怀化市"],
        [98.854304, 25.850949, "怒江市"],
        [114.412599, 23.079404, "惠州市"],
        [104.066143, 30.573095, "成都市"],
        [119.421003, 32.393159, "扬州市"],
        [117.939152, 40.976204, "承德市"],
        [116.358351, 27.98385, "抚州市"],
        [123.921109, 41.875956, "抚顺市"],
        [91.171961, 29.653482, "拉萨市"],
        [116.355733, 23.543778, "揭阳市"],
        [101.716008, 26.580446, "攀枝花市"],
        [104.24401, 23.36951, "文山市"],
        [114.930835, 27.810835, "新余市"],
        [120.301663, 31.574729, "无锡市"],
        [88.88416, 29.241745, "日喀则市"],
        [119.461208, 35.428588, "日照市"],
        [120.980737, 31.385598, "昆山市"],
        [102.833722, 24.881539, "昆明市"],
        [87.304012, 44.014577, "昌吉市"],
        [104.0806, 30.693417, "昌江市"],
        [112.736465, 37.696495, "晋中市"],
        [112.851274, 35.497553, "晋城市"],
        [100.972344, 22.777321, "普洱市"],
        [117.214664, 29.29256, "景德镇市"],
        [103.797851, 25.501557, "曲靖市"],
        [112.433387, 39.331261, "朔州市"],
        [120.451176, 41.576758, "朝阳市"],
        [123.770519, 41.297909, "本溪市"],
        [120.209947, 30.245853, "杭州市"],
        [124.823608, 45.118243, "松原市"],
        [94.36113, 29.647534, "林芝市"],
        [117.557964, 34.856424, "枣庄市"],
        [104.222079, 30.865398, "柳州市"],
        [113.151737, 27.835806, "株洲市"],
        [110.299121, 25.274215, "桂林市"],
        [116.117582, 24.299112, "梅州市"],
        [111.297604, 23.474803, "梧州市"],
        [101.546046, 25.041988, "楚雄市"],
        [109.741193, 38.290162, "榆林市"],
        [114.305215, 30.592935, "武汉市"],
        [105.28501, 27.301693, "毕节市"],
        [111.608019, 26.434516, "永州市"],
        [107.028621, 33.077668, "汉中市"],
        [116.708463, 23.37102, "汕头市"],
        [115.364238, 22.774485, "汕尾市"],
        [113.094942, 22.590431, "江门市"],
        [117.489157, 30.656037, "池州市"],
        [123.465009, 41.677287, "沈阳市"],
        [116.857461, 38.310582, "沧州市"],
        [108.062106, 24.695899, "河池市"],
        [114.697802, 23.746266, "河源市"],
        [118.675847, 24.87435, "泉州市"],
        [117.129063, 36.194968, "泰安市"],
        [119.915176, 32.484882, "泰州市"],
        [105.443349, 28.889138, "泸州市"],
        [112.434468, 34.663041, "洛阳市"],
        [117.120098, 36.6512, "济南市"],
        [116.587245, 35.415393, "济宁市"],
        [112.601919, 35.067243, "济源市"],
        [118.038225, 36.804008, "淄博市"],
        [104.051754, 30.690583, "海口市"],
        [116.794664, 33.971707, "淮北市"],
        [117.018329, 32.647574, "淮南市"],
        [119.021265, 33.597506, "淮安市"],
        [114.085947, 22.547, "深圳市"],
        [113.051227, 23.685022, "清远市"],
        [120.672111, 28.000575, "温州市"],
        [109.502882, 34.499381, "渭南市"],
        [120.102398, 30.867198, "湖州市"],
        [112.944052, 27.82973, "湘潭市"],
        [110.364977, 21.274898, "湛江市"],
        [118.316264, 32.303627, "滁州市"],
        [118.016974, 37.383542, "滨州市"],
        [114.026405, 33.575855, "漯河市"],
        [117.661801, 24.510897, "漳州市"],
        [119.107078, 36.70925, "潍坊市"],
        [116.632301, 23.661701, "潮州市"],
        [113.464758, 22.155678, "澳门"],
        [115.041299, 35.768234, "濮阳市"],
        [121.391382, 37.539297, "烟台市"],
        [113.238266, 35.23904, "焦作市"],
        [129.618602, 44.582962, "牡丹江市"],
        [110.180962, 22.653889, "玉林市"],
        [102.543907, 24.350461, "玉溪市"],
        [113.553986, 22.224979, "珠海市"],
        [110.466785, 19.246011, "琼海市"],
        [101.963815, 30.050663, "甘孜市"],
        [122.841114, 45.619026, "白城市"],
        [126.427839, 41.942505, "白山市"],
        [106.616285, 23.897742, "百色市"],
        [112.355042, 28.570066, "益阳市"],
        [120.139998, 33.377631, "盐城市"],
        [122.069571, 41.124484, "盘锦市"],
        [103.831788, 30.048318, "眉山市"],
        [114.514793, 38.042225, "石家庄市"],
        [86.041075, 44.305886, "石河子市"],
        [103.884961, 30.821073, "神农架林区市"],
        [119.296389, 26.074268, "福州市"],
        [119.586579, 39.942531, "秦皇岛市"],
        [103.962328, 30.536917, "红河市"],
        [120.582112, 29.997117, "绍兴市"],
        [104.741722, 31.46402, "绵阳市"],
        [115.980367, 36.456013, "聊城市"],
        [112.472529, 23.051546, "肇庆市"],
        [104.773447, 29.352765, "自贡市"],
        [122.106863, 30.016028, "舟山市"],
        [118.376451, 31.326319, "芜湖市"],
        [120.619585, 31.299379, "苏州市"],
        [110.919229, 21.659751, "茂名市"],
        [112.23813, 30.326857, "荆州市"],
        [112.204251, 31.03542, "荆门市"],
        [119.007558, 25.431011, "莆田市"],
        [117.677736, 36.214397, "莱芜市"],
        [115.469381, 35.246531, "菏泽市"],
        [113.852186, 27.622946, "萍乡市"],
        [122.243048, 40.663664, "营口市"],
        [120.856394, 40.755572, "葫芦岛市"],
        [117.363228, 32.939667, "蚌埠市"],
        [115.665993, 37.735097, "衡水市"],
        [112.607693, 26.900358, "衡阳市"],
        [118.87263, 28.941708, "衢州市"],
        [112.144146, 32.042426, "襄阳市"],
        [100.797941, 22.001724, "西双版纳市"],
        [101.778112, 36.617042, "西宁市"],
        [104.0629, 30.578507, "西安市"],
        [113.826063, 34.022956, "许昌市"],
        [109.602146, 23.0936, "贵港市"],
        [106.630153, 26.647661, "贵阳市"],
        [111.552057, 24.414141, "贺州市"],
        [104.641917, 30.122211, "资阳市"],
        [114.940278, 25.85097, "赣州市"],
        [118.886856, 42.257817, "赤峰市"],
        [125.145349, 42.902692, "辽源市"],
        [123.18152, 41.269402, "辽阳市"],
        [107.468023, 31.209572, "达州市"],
        [111.003957, 35.022778, "运城市"],
        [119.178821, 34.600018, "连云港市"],
        [99.706463, 27.826853, "迪庆市"],
        [125.936501, 41.721177, "通化市"],
        [122.263119, 43.617429, "通辽市"],
        [105.571331, 30.513311, "遂宁市"],
        [106.937265, 27.706626, "遵义市"],
        [114.508851, 37.0682, "邢台市"],
        [114.490686, 36.612273, "邯郸市"],
        [104.032794, 30.711923, "郑州市"],
        [113.014718, 25.77051, "郴州市"],
        [109.99029, 39.817179, "鄂尔多斯市"],
        [114.890593, 30.396536, "鄂州市"],
        [98.494352, 39.732819, "酒泉市"],
        [106.550464, 29.563761, "重庆市"],
        [119.649506, 29.089524, "金华市"],
        [108.624175, 21.967127, "钦州市"],
        [123.844279, 42.290585, "铁岭市"],
        [109.191555, 27.718346, "铜仁市"],
        [108.979608, 34.916582, "铜川市"],
        [117.816576, 30.929935, "铜陵市"],
        [106.230909, 38.487193, "银川市"],
        [116.090996, 43.944018, "锡林郭勒盟市"],
        [121.135742, 41.119269, "锦州市"],
        [119.452753, 32.204402, "镇江市"],
        [125.323628, 43.817001, "长春市"],
        [104.137367, 30.643938, "长沙市"],
        [113.113556, 36.191112, "长治市"],
        [121.648962, 42.011796, "阜新市"],
        [115.819729, 32.896969, "阜阳市"],
        [111.982697, 21.857415, "阳江市"],
        [113.583285, 37.861188, "阳泉市"],
        [80.273643, 41.132649, "阿克苏市"],
        [104.929379, 33.388598, "陇南市"],
        [110.037455, 18.504654, "陵水市"],
        [113.382477, 31.690187, "随州市"],
        [103.001033, 29.987722, "雅安市"],
        [120.324447, 36.064594, "青岛市"],
        [122.995632, 41.110626, "鞍山市"],
        [113.597313, 24.811094, "韶关市"],
        [114.165243, 22.274701, "香港"],
        [118.506502, 31.669611, "马鞍山市"],
        [114.024736, 32.980169, "驻马店市"],
        [114.295444, 35.748236, "鹤壁市"],
        [117.033838, 28.238638, "鹰潭市"],
        [114.879365, 30.447711, "黄冈市"],
        [118.317325, 29.709239, "黄山市"],
        [115.077048, 30.220074, "黄石市"],
        [107.976125, 26.583076, "黔东南市"],
        [107.517156, 26.258219, "黔南市"],
        [105.186077, 25.431043, "黔西南市"],
        [123.95792, 47.342081, "齐齐哈尔市"],
        [117.01728, 25.075097, "龙岩市"]
      ],
    }
  },
  methods: {
    createPoint(map, data, opt) {
      for (var i = 0; i < data.length; i++) {
        if (opt == 1) {//普通城市
          var myIcon = new BMap.Icon("https://spkg.smartmice.cn/resources/images/official/index/point_city.png", new BMap.Size(12, 12));
          var myIcon_strong = new BMap.Icon("https://spkg.smartmice.cn/resources/images/official/index/point.png", new BMap.Size(12, 12));
          var myIcon_over = new BMap.Icon("https://spkg.smartmice.cn/resources/images/official/index/point_hover.png", new BMap.Size(12, 12));
        }
        else if (opt == 2) {//重要城市
          var myIcon = new BMap.Icon("https://spkg.smartmice.cn/resources/images/official/index/point_four.png", new BMap.Size(12, 12));
          var myIcon_over = new BMap.Icon("https://spkg.smartmice.cn/resources/images/official/index/point_hover.png", new BMap.Size(12, 12));
        }
        else if (opt == 3) {//国际城市
          var myIcon = new BMap.Icon("https://spkg.smartmice.cn/resources/images/official/index/point.png", new BMap.Size(12, 12));
          var myIcon_over = new BMap.Icon("https://spkg.smartmice.cn/resources/images/official/index/point_hover.png", new BMap.Size(12, 12));
        }
        var marker = new BMap.Marker(new BMap.Point(data[i][0], data[i][1]), {icon: myIcon});
        map.addOverlay(marker);
        if (opt == 1) {
          this.changeZoom(map, marker, myIcon, myIcon_over, myIcon_strong)
        }
        this.createInfoBox(map, marker, data[i], myIcon, myIcon_over)
      }
    },
    createInfoBox(map, marker, data, myIcon, myIcon_over) {
      var html = [
        "<div style='position: relative'><span style='margin-left: 10px;width: 88px;height: 27px;background: #f97a21;text-align: center;line-height: 27px;color: #fff;display: inline-block;'>" 
        + data[2] + 
        "</div><div style='margin-left: 88px;border-style: solid;border-width: 0px 10px 20px 0px;border-color: transparent #f97a21 transparent transparent;width: 0px;height: 0px;'></div></div>" 
      ];
      var infoBox = new BMapLib.InfoBox(map, html.join(""), {
        boxStyle: {
          width: "200px"
        }
      });
      marker.addEventListener("onmouseover", function () {
        this.setIcon(myIcon_over)
        infoBox.open(this);
      });
      marker.addEventListener("onmouseout", function () {
        this.setIcon(myIcon)
        infoBox.hide()
      })
    },
    changeZoom(map, marker, myIcon, myIcon_over, myIcon_strong) {
      map.addEventListener("zoomend", function () {
        if (map.getZoom() >= 4) {
          marker.setIcon(myIcon_strong);
          marker.addEventListener("onmouseover", function () {
            this.setIcon(myIcon_over)
          });
          marker.addEventListener("onmouseout", function () {
            this.setIcon(myIcon_strong)
          })
        }  else {
          marker.setIcon(myIcon)
          marker.addEventListener("onmouseover", function () {
            this.setIcon(myIcon_over)
          });
          marker.addEventListener("onmouseout", function () {
            this.setIcon(myIcon)
          })
        }
      })
    }
  },
  mounted() {
    let map = new BMap.Map("allmap");
    map.centerAndZoom(new BMap.Point(0,25), 1);
    map.disableDragging();
    map.setMapStyle({
            styleJson: [
                {
                    "featureType": "land",
                    "elementType": "all",
                    "stylers": {
                        "color": "#969696",
                        "visibility": "on"
                    }
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": {
                        "color": "#ffffff",
                        "visibility": "on"
                    }
                },
                {
                    "featureType": "green",
                    "elementType": "all",
                    "stylers": {
                        "visibility": "off"
                    }
                },
                {
                    "featureType": "manmade",
                    "elementType": "all",
                    "stylers": {
                        "visibility": "off"
                    }
                },
                {
                    "featureType": "building",
                    "elementType": "all",
                    "stylers": {
                        "visibility": "off"
                    }
                },
                {
                    "featureType": "label",
                    "elementType": "all",
                    "stylers": {
                        "color": "#ffffff",
                        "visibility": "off"
                    }
                },
                {
                    "featureType": "boundary",
                    "elementType": "all",
                    "stylers": {
                        "color": "#ffffff",
                        "weight": "0.1"
                    }
                }]
        });
    this.createPoint(map, this.china_city, 1)
    this.createPoint(map, this.world_city, 3)
    this.createPoint(map, this.fire_city, 2)
  }
}
</script>
<style lang="less" scoped>
@media (min-width: 997px) {
  #allmap {
    height: 600px;
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
    .map {
      width: 100%;
      height: 600px;
    }
  }
}
@media (max-width: 997px) {
  #allmap {
    height: 300px;
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
    .map {
      width: 100%;
      height: 300px;
    }
  }
}

.sub img {
    vertical-align: top;
    width: auto;
}
</style>